import { ReactElement, ReactNode, createContext, useContext } from 'react';
import { Wizard, WizardProps, WizardValues } from 'react-use-wizard';

import useWizardLogic from './wizard.hooks';

interface WizardEnrichment {
  urlControl?: boolean;
  stepParamName?: string;
}
interface Props extends WizardProps, WizardEnrichment {
  children: ReactElement<any>[];
}

export type WizardContextType = WizardValues | null;

export const WizardContext = createContext<WizardContextType>(null);

export const WizardProvider = ({ children, urlControl, stepParamName, ...rest }: Props) => {
  return (
    <Wizard {...rest}>
      {(children as ReactElement<any>[])?.map((child, index) => (
        <WizardEnrichmentProvider urlControl={urlControl} stepParamName={stepParamName} key={index}>
          {child}
        </WizardEnrichmentProvider>
      ))}
    </Wizard>
  );
};

interface EnrichmentProps extends WizardProps, WizardEnrichment {
  children: ReactNode;
}

const WizardEnrichmentProvider = ({ children, urlControl, stepParamName = 'step' }: EnrichmentProps) => {
  const { value } = useWizardLogic({ urlControl, stepParamName });

  return <WizardContext.Provider value={value}>{children}</WizardContext.Provider>;
};

export const useWizard = () => {
  const context = useContext(WizardContext);
  if (context === null) throw new Error('useWizard must be used within a WizardProvider');
  return context;
};
